import { forwardRef, type CSSProperties, type ForwardedRef, type ReactElement } from 'react';
import type { SortDir } from '@/lib/tableSort';

interface SortableHeaderProps<K extends string> {
  label: string;
  sortKey: K;
  sort: { key: K | null; dir: SortDir };
  onSort: (key: K) => void;
  className?: string;
  style?: CSSProperties;
}

/** ref прокинут до самого <th> — нужен там, где реальную ширину/позицию колонки надо измерить (см. закреплённые колонки в ClientsPage). */
function SortableHeaderInner<K extends string>(
  { label, sortKey, sort, onSort, className, style }: SortableHeaderProps<K>,
  ref: ForwardedRef<HTMLTableCellElement>,
) {
  const active = sort.key === sortKey;
  return (
    <th
      ref={ref}
      className={`th-sortable${className ? ` ${className}` : ''}`}
      style={style}
      onClick={() => onSort(sortKey)}
    >
      {label}
      <span className={`th-sortable__ico${active ? ' th-sortable__ico--active' : ''}`}>
        {active && sort.dir === 'desc' ? '▼' : '▲'}
      </span>
    </th>
  );
}

export const SortableHeader = forwardRef(SortableHeaderInner) as <K extends string>(
  props: SortableHeaderProps<K> & { ref?: ForwardedRef<HTMLTableCellElement> },
) => ReactElement;
